import { AdditionalField } from './additional-field.model';
import { Enrollment } from './enrollment.model';
import { LMSSubscription } from './lms-subscription.model';

/**
 * Docebo User model
 */
export class User {
  constructor(
    public id: number,
    public username: string,
    public firstname: string,
    public lastname: string,
    public email: string,
    public avatarUrl: string,
    public additionalFields: AdditionalField[], // NOTE: User account name or company name is needed for Pendo
    public activeSubscriptions: LMSSubscription[], // Shows active subscriptions the user has subscribed
    public enrollments: Enrollment[] // Shows active enrollments of courses (based on an active subscription)
  ) {}
}
